import {createApp} from 'vue'
import ImageGallery from './ImageGallery'

const el = '.kb-component--image-gallery'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((ImageGalleryDOM)=>{
            const imgs = JSON.parse(ImageGalleryDOM.dataset.imgs)
            const type = ImageGalleryDOM.dataset.type
            const component = createApp(ImageGallery, {imgs, type}).use(Store)
            component.mount(ImageGalleryDOM)
        })
    }
}